import type { Image } from 'mdast';

import type { State } from '../state';

export function image(state: State, node: Image): void {
	const nodeType = state.schema.nodes.image;
	if (!nodeType) {
		// Gracefully degrade: schema has no image node — render alt text as plain text
		if (node.alt) {
			state.addText(node.alt);
		}
		return;
	}
	state.addNode(nodeType, { src: node.url, alt: node.alt ?? null, title: node.title ?? null }, []);
}
